module.exports = __webpack_public_path__ + "img/16_70.920b0e40.png";